<template>
  <cell :class="[baseCss]" :x-align="xAlign" :style="{width}">
    <div :class="['absolute', 'top-0', 'bottom-0', 'h-full', setBgColor('barColor', 'barColorLightness')]" :style="{width: barWidth}" />
    <span @click="$emit('click')" :class="[cursor ? `cursor-${cursor}` : null, 'bcq-timeline-item-bar-circle', 'relative', 'inline-block', 'rounded-full', setBgColor('barColor', 'barColorLightness')]" :style="{padding: barWidth}">
      <span :class="['inline-block', 'rounded-full', setBgColor('barBgColor', 'barBgColorLightness')]">
        <icon :provider="iconProvider" :class="[icon ? null : 'invisible', 'm-1']" :name="icon ? icon : 'home'" :color="iconColor" :size="iconSize" :color-lightness="iconColorLightness" />
      </span>
    </span>
  </cell>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'TimelineItemBar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('timeline-item-bar', ['relative', 'text-center', 'select-none'])
    }
  },
  props: {
    icon: {
      type: String
    },
    xAlign: {
      type: String,
      default: 'center'
    },
    barWidth: {
      type: String,
      default: '2px'
    },
    width: {
      type: String,
      default: '10%'
    },
    barColor: {
      type: String,
      default: 'black'
    },
    barColorLightness: {
      type: Number,
      default: null
    },
    barBgColor: {
      type: String,
      default: 'white'
    },
    barBgColorLightness: {
      type: Number,
      default: null
    },
    iconColor: {
      type: String
    },
    iconColorLightness: {
      type: Number
    },
    iconSize: {
      type: Number
    },
    cursor: {
      type: String,
      cursor: 'default'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/timeline-item-bar/timeline-item-bar.vue